module.exports = __webpack_public_path__ + "img/dd-logo-infiniti-w.2c5decd0.png";